var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._g({staticClass:"v-icon",class:{ 'stroke-width': _vm.strokeWidth !== null, fill: _vm.fill !== null },style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.icon)}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }